import classNames from "classnames";
import { IFormItem } from "./form-item.types";

export const FormItem: IFormItem = ({ label, error, className, required, children, focused }) => {
  return (
    <div
      className={classNames(
        "input-wrapper min-h-[60px] p-[20px] relative flex flex-row items-center bg-base-05",
        className,
        { "border-error": !!error, "border-2": !!error }
      )}
    >
      {label && (
        <div
          className={classNames("flex flex-row absolute duration-200 ease-in", {
            "left-[20px] top-[19px]": !focused,
            "left-[20px] top-[10px]": focused,
          })}
        >
          <span
            className={classNames("font-[800] duration-200 ease-in uppercase", {
              "text-[18px]": !focused,
              "text-[10px] tracking-normal": focused,
              "text-error": error,
              "text-white": !error,
            })}
          >
            {label}
          </span>
          {required && (
            <span
              className={classNames("font-[700] duration-200 ease-in text-text-04 tracking-normal", {
                "text-[18px]": !focused,
                "text-[10px]": focused,
              })}
            >
              *
            </span>
          )}
        </div>
      )}
      {children}
      {error && <span className="form-error">{error}</span>}
    </div>
  );
};
